import Component_GUIDemo_f05b04dc305d6d77dcf4f08f7080b905 from "../../../../content/examples/gui/gui-demo/GUIDemo";
import Devtool_GUIDemo_f05b04dc305d6d77dcf4f08f7080b905 from "!!@devtool/loader!../../../../content/examples/gui/gui-demo/GUIDemo";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_GUIDemo_f05b04dc305d6d77dcf4f08f7080b905,
  Devtool_GUIDemo_f05b04dc305d6d77dcf4f08f7080b905,
  DevTool,
  React
};